export default "__VITE_ASSET__BpL0Vl5c__"